{
    "coordinates": [
        36.555985212596966,
        118.69119349644467
    ],
    "tooltip": "Shanwang",
    "title": "Shanwang Formation",
    "country": "China",
    "period": "Neogene",
    "alt": "TODO"
}
